<template lang="pug">
div
  div(v-if="floatWindowTabs && floatWindowTabs.length >= 1")
      float-window(
        v-for="(w, index) in floatWindowTabs"
        :key="w.uuid"
        :name="`${w.type.uuid}`"
        :tabs="w"
        :index="index"
      )
  the-header
  .px-3.header-padding
      yuri-menu.sticky
      .bg-white.content(:class="{ 'px-3': subitems.length < 1, 'FullScreenLayout': isFullScreen }")
          router-view
</template>

<style lang="sass">
.FullScreenLayout
    position: fixed
    top: 0
    left: 0
    width: 100vw
    height: 100vh
    z-index: 15
    overflow-y: auto
</style>

<script>
import FloatWindow from '@/components/float-window/index.vue';
import TheHeader from '@/components/the-header/index.vue';
import YuriMenu from '@/components/yuri-menu/index.vue';

export default {
    components: {
        FloatWindow,
        TheHeader,
        YuriMenu
    },
    computed: {
        /**
         * @override
         */
        subitems() {
            return this.$store.getters['yuriMenuStore/activeItemChildrens'];
        },
        /**
         * @override
         */
        floatWindowTabs() {
          return this.$store.getters['bastanteoStore/tabs'];
        },
        isFullScreen() {
            return this.$store.getters['fullscreenStore/fullscreen'];
        }
    }
};
</script>
